function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M632,37c4.4,0,8-3.6,8-8V13c0-4.4-3.6-8-8-8H8c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8h8v384H8c-4.4,0-8,3.6-8,8v16 c0,4.4,3.6,8,8,8h624c4.4,0,8-3.6,8-8v-16c0-4.4-3.6-8-8-8h-8V37H632z M592,421H48V37h544V421z M120,357h16c4.4,0,8-3.6,8-8V109 c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v240C112,353.4,115.6,357,120,357z M216,357h16c4.4,0,8-3.6,8-8V109c0-4.4-3.6-8-8-8h-16 c-4.4,0-8,3.6-8,8v240C208,353.4,211.6,357,216,357z M312,357h16c4.4,0,8-3.6,8-8V109c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v240 C304,353.4,307.6,357,312,357z M408,357h16c4.4,0,8-3.6,8-8V109c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v240 C400,353.4,403.6,357,408,357z M504,357h16c4.4,0,8-3.6,8-8V109c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v240 C496,353.4,499.6,357,504,357z"
});

const SvgContainerToShip = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 457",
    style: {
      enableBackground: "new 0 0 640 457"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContainerToShip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/container-to-ship.c03a9aba.svg";
export { ForwardRef as ReactComponent };